<template>
    <div class="listRight">
        <div class="item">
            <div class="imageLeft">
                <img src="../assets/images/news-img-3.jpg" alt>
            </div>
            <div class="newRight">
                <div class="newTitle">
                    <router-link to="/news/news-detail-3">上半年跨境电商进口货值；无锡跨境电商综试区；社交电商...</router-link>
                    <span>2019-07-26</span>
                </div>
                <div class="newDescription">
                    <span>广阔的大洋彼岸，美国、加拿大和墨西哥三国组成了亚马逊北美主要消费区域，拥有将近5亿人。 美国：美国电商市场规模庞大，连年保持2位数…</span>
                    <router-link to="/news/news-detail-3">阅读更多</router-link>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="imageLeft">
                <img src="../assets/images/news-img-2.jpg" alt>
            </div>
            <div class="newRight">
                <div class="newTitle">
                    <router-link to="/news/news-detail-2">葡萄酒跨境电商交易；关税豁免；深圳鼎付暂停收款...</router-link>
                    <span>2019-07-12</span>
                </div>
                <div class="newDescription">
                    <span>湖北首家依托一带一路、中欧班列打造的葡萄酒保税仓10日举行开仓仪式。后期，该省将依托汉欧班列与武汉法国葡萄酒保税仓，建设葡萄酒跨境电…</span>
                    <router-link to="/news/news-detail-2">阅读更多</router-link>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="imageLeft">
                <img src="../assets/images/news-img-1.png" alt>
            </div>
            <div class="newRight">
                <div class="newTitle">
                    <router-link to="/news/news-detail-1">跨境电商零售；Lazada年中大促；亚马逊以色列希伯来语...</router-link>
                    <span>2019-07-05</span>
                </div>
                <div class="newDescription">
                    <span>从海关总署获悉，全国海关已经开启下半年知识产权保护专项行动。专项行动中，海关将加强与地方有关部门间执法协作，全方位加强对输往海外…</span>
                    <router-link to="/news/news-detail-1">阅读更多</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .listRight {
        padding-left: 30px;
        flex: 1;
        .item {
            display: flex;
            flex-flow: nowrap row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            height: 176px;
            .imageLeft {
                width: 278px;
                height: 176px;
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .newRight {
                height: 176px;
                padding-left: 20px;
                background: rgba(250, 250, 250, 1);
                flex: 1;

                display: flex;
                flex-flow: nowrap row;
                justify-content: space-between;
                align-items: center;
                .newTitle {
                    width: 200px;
                    height: 136px;
                    padding: 40px 0;
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: space-between;
                    align-items: flex-start;
                    a {
                        display: block;
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 28px;
                        color: #323232;
                    }
                    span {
                        font-size: 14px;
                    }
                }
                .newDescription {
                    flex: 1;
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: space-between;
                    align-items: flex-start;
                    height: 130px;
                    padding: 0 20px;
                    border-left: 1px solid #ddd;
                    span {
                        font-size: 14px;
                        color: rgba(50, 50, 50, 0.6);
                        line-height: 26px;
                    }
                    a {
                        display: block;
                        width: 96px;
                        height: 36px;
                        font-size: 14px;
                        font-weight: normal;
                        text-align: center;
                        line-height: 36px;
                        color: #fff;
                        background: rgba(18, 10, 76, 0.4);
                        &:hover {background: rgba(18, 10, 76, 0.8);}
                    }
                }
            }
        }
    }
</style>


<script>
import store from '../vuex'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/news.png'),
            text: 'NEWS',
        }
      }
  },
  components:{},
  store,
}
</script>

